import { render } from "./Supplier_selection.vue?vue&type=template&id=6061dd5e"
import script from "./Supplier_selection.vue?vue&type=script&lang=js"
export * from "./Supplier_selection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__